import { useEffect } from "react";
import L from "leaflet";
import "./Legend.css";

function Legend({ map,position }) {
  useEffect(() => {
    if (map) {
      const legend = L.control({ position: position });

      legend.onAdd = () => {
        const div = L.DomUtil.create("div", "cutsom_legend");
        div.innerHTML =
          "<p class='legend-title'>DISCOUNT KEY</p>" +
          "";
        return div;
      };

      legend.addTo(map);
    }
  }, [map,position]);
  return null;
}

export default Legend;
